<div class="cds-flex cds-flex-col cds-gap-1 cds-items-end cds-my-4">
  <button
    cbButton
    [label]="isRemoving ? 'Removing...' : 'Remove Cover'"
    [disabled]="isRemoving"
    class="!cds-text-[#aa010e] sm:disabled:!cds-pr-[40px] sm:!cds-pr-0 hover:!cds-text-[#aa010e] disabled:!cds-text-[#afafaf] cds-transition-colors cds-duration-200"
    variant="ghost"
    iconColor="error-shade"
    leftIcon="utility-trash-stroke"
    (click)="handleModal()"
    data-testid="policy-coverage-remove-button"></button>
</div>

<div>
  <cb-modal
    [open]="open"
    (closeEvent)="handleModal()"
    [title]="'Remove ' + coverageRefDescription"
    [closeOnEscape]="false"
    customContent="true"
    [hideCloseIcon]="false"
    [hideDefaultFooter]="true"
    data-testid="policy-coverage-remove-modal">
    <div class="cds-mb-8">
      @if (canDelete) {
        <p>Are you sure you want to remove this coverage from {{ customerName }}?</p>
      }
      @if (!canDelete) {
        <p>Cannot remove the last coverage from {{ customerName }}.</p>
      }
    </div>
    <div class="cds-flex cds-gap-3 cds-justify-end">
      <button
        cbButton
        label="Cancel"
        variant="secondary"
        colorTheme="purple"
        data-testid="policy-coverage-remove-modal-cancel-button"
        (click)="handleModal()"></button>
      <button
        cbButton
        label="Remove"
        variant="primary"
        colorTheme="purple"
        data-testid="policy-coverage-remove-modal-remove-button"
        (click)="remove()"
        [disabled]="!canDelete"></button>
    </div>
  </cb-modal>
</div>
